
export default {
  props: {
    linkLabel: {
      type: String,
      default: 'Login with email'
    }
  },
  emits: ['action']
}
